import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { PictureInfo } from "../photo-and-remark/photo-viewmodel";
@Component({
  selector: "app-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.scss"],
})
export class SliderComponent implements OnInit, AfterViewInit {
  @ViewChild("backButton") back: ElementRef<HTMLDivElement>;
  @ViewChild("forwardButton") forward: ElementRef<HTMLDivElement>;
  public hidePrevious = false;
  public hideNext = false;
  currentSliderImage = "";
  @Input() selectedImage: boolean;
  @Input() sliderPhotos: PictureInfo[] = [];
  @Input() currentImage: PictureInfo;
  @Input() limit: number;
  @Input() title: string;
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();

  constructor(private _sanitizer: DomSanitizer) {}
  ngAfterViewInit(): void {
    // HammerJS swipe has a bug on android detecting touchend of the swipe event. Thats why the first button click get overruled.
    // below are 2 event listeners to work around the bug. this is not final code as when the bug would be resolved in hammerJS we can remove this piece of code
    this.back.nativeElement.addEventListener(
      "touchstart",
      function (event) {
        this.click();
        event.preventDefault();
      },
      { passive: false }
    );
    this.forward.nativeElement.addEventListener(
      "touchstart",
      function (event) {
        this.click();
        event.preventDefault();
      },
      { passive: false }
    );
  }

  onSwipe(event) {
    if (event.offsetDirection == 2 && !this.hideNext) this.navigateImage(1);
    if (event.offsetDirection == 4 && !this.hidePrevious)
      this.navigateImage(-1);
  }

  ngOnInit(): void {
    this.currentSliderImage = this.currentImage?.data.url;
    var index = this.sliderPhotos?.findIndex(
      (x) => x.data.url == this.currentImage.data.url
    );
    this.hidePrevious = index <= 0;
    this.hideNext = index >= this.sliderPhotos.length - 1;
  }

  closeViewer() {
    this.closeSlider.emit(!this.selectedImage);
  }

  transform(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  public navigateImage(move: number) {
    var index = this.sliderPhotos.findIndex(
      (x) => x.data.url == this.currentImage.data.url
    );
    if (index >= 0 && index < this.sliderPhotos.length)
      this.currentImage = this.sliderPhotos[index + move];
    else return;
    this.hidePrevious = index == 1 && move == -1;
    this.hideNext = index == this.sliderPhotos.length - 2 && move == 1;
  }
}
